import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { PageParams } from '../../../../../core/models/page-params.model';
import { ConstantService } from '../../../../../core/services/constant.service';
import { NotificationService } from '../../../../../core/services/notification.service';
import { UserService } from '../../../../../core/services/user.service';
import { PartnerService } from '../../../../../modules/partner-management/services/partner.service';
import { CompanyService } from '../../../../../core/services/company.service';
import { ReportingToolService } from '../../../reporting-tool.service';
import { LocalStorageService } from '../../../../../core/services/local-storage.service';
import { IReportedTaxReportItems } from '../../../models/reported-tax-report-items';
import { Roles } from '../../../../../shared/enums/role-types.enum';
import { ICompany } from '../../../../../modules/customer-registration/models/company.model';
import { TaxReportType } from "../../../../../shared/enums/tax-report-type.enum";

import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE
} from '@angular/material/core';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS
} from '@angular/material-moment-adapter';

import * as _moment from 'moment';
import { Moment } from 'moment';
import { TaxReportService } from '../../../../new-tax-report-management/services/tax-report.service';
import { reportQuarter } from '../../../../../shared/enums/quarter.enum';

const moment = _moment;

// show only month-year
export const MONTH_YEAR_FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'eci-reported-tax-report-tab',
  templateUrl: './reported-tax-report-tab.component.html',
  styleUrls: ['./reported-tax-report-tab.component.scss'],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMATS },
  ],
})

export class ReportedTaxReportTabComponent implements OnInit {
  @ViewChild('table') table!: ElementRef;

  isAdmin = false;
  isPartner = false;
  showLoader = false;
  isRegularTab = false;
  reportType: TaxReportType = TaxReportType.OSS;
  displayedColumns: string[] = [];
  countriesList: any;
  partnerList = [];
  companyList: ICompany[] | undefined;
  partnerId = '';
  previousPageCompany = 0;
  totalPageCompany = 1;
  partners: FormControl = new FormControl('');
  searchPartnerName: FormControl = new FormControl('');
  customers: FormControl = new FormControl('');
  searchCustomerName: FormControl = new FormControl('');
  search: FormControl = new FormControl('');
  country: FormControl = new FormControl([]);
  selectedCountry: FormControl = new FormControl([]);
  searchSelectedCountry: FormControl = new FormControl('');
  dateFrom: FormControl = new FormControl('');
  dateTo: FormControl = new FormControl('');
  pageParams: PageParams = new PageParams();
  dataSource = new MatTableDataSource<IReportedTaxReportItems>([]);

  constructor(
    public userSvc: UserService,
    private activatedRoute: ActivatedRoute,
    private taxReportSvc: TaxReportService,
    private constSvc: ConstantService,
    private partnerService: PartnerService,
    private companyService: CompanyService,
    public dialog: MatDialog,
    private notify: NotificationService,
    public reportingToolService: ReportingToolService,
    private localStorageSvc: LocalStorageService,
  ) {}

  ngOnInit(): void {
    if (this.userSvc.isAdmin) this.isAdmin = true;
    if (this.userSvc.isPartnerAccount) this.isPartner = true;

    if(this.isAdmin){
      this.getPartnersList();
      this.getCompanyList();
    }

    if(this.isPartner){
      this.partnerId = this.userSvc.user.id;
      this.getPartnerCompanyList();
    }

    this.activatedRoute.data.subscribe(({ reportType }) => {
      this.reportType = reportType;

      this.isRegularTab = this.reportType === TaxReportType.Regular || this.reportType === TaxReportType.Purchases;
      const userRole = this.localStorageSvc.get('user').role;

      if (this.showCountryFilter) {
        this.getListCountries();
      }
      this.displayedColumns = this.getDisplayedColumns(this.reportType, userRole);

      const savedFilters = this.localStorageSvc.get('reportedTaxReportFilters');
      if (savedFilters) {
        if (savedFilters.fromYear && savedFilters.fromMonth) {
          this.dateFrom.setValue(moment(`${savedFilters.fromYear}-${savedFilters.fromMonth}-01`));
        }
        if (savedFilters.toYear && savedFilters.toMonth) {
          this.dateTo.setValue(moment(`${savedFilters.toYear}-${savedFilters.toMonth}-01`));
        }
        if (savedFilters.partnerId) this.partners.setValue(savedFilters.partnerId);
        if (savedFilters.customerId) this.customers.setValue(savedFilters.customerId);
        if (this.isRegularTab && savedFilters.countryCode) this.country.setValue(savedFilters.countryCode);
      }

      this.getList();
    });

    this.partners.valueChanges.subscribe(value => {
      this.previousPageCompany = 0;
      this.totalPageCompany = 1;
      this.companyList = [];
      if (value.length > 0) {
        this.partnerId = value;
        this.getPartnerCompanyList(1);
      } else {
        this.getCompanyList();
      }
    });
  }

  chosenMonthHandler(normalizedMonth: Moment, control: FormControl, datepicker: any) {
    const ctrlValue = control.value || moment();
    ctrlValue.month(normalizedMonth.month()).year(normalizedMonth.year());
    control.setValue(ctrlValue.clone());
    datepicker.close();
    if (control === this.dateFrom && this.dateTo.value && this.dateTo.value.isBefore(this.dateFrom.value)) {
      this.dateTo.setValue('');
    }
  }

  getList(
    page: number = 1,
    limit: number = 100,
    filters: any = this.prepareSearchParams()
  ): void {
    this.showLoader = true;
    this.taxReportSvc.getReportsDataWithReportsType(
      page,
      limit,
      this.reportType,
      filters.fromMonth,
      filters.fromYear,
      filters.toMonth,
      filters.toYear,
      filters.partnerId,
      filters.customerId,
      filters.countryCode
    ).subscribe(data => {
      if (!data) {
        return;
      }
      const transformed = data.items.map((item: any) => {
        const date = new Date(item.reportYear, item.reportMonth - 1);
        return {
          month: item.reportMonth,
          year: item.reportYear,
          isQuarterly: item.isQuarterly,
          quarter: reportQuarter[item.quarter],
          timePeriod: item.isQuarterly ? reportQuarter[item.quarter] + ' ' + item.reportYear : date.toLocaleString('default', {
            month: 'long',
            year: 'numeric'
          }),
          partnerName: item.partner?.contactName ?? '',
          customerName: item.customer?.name ?? '',
          countryCode: item.countryCode,
          fileUrl: item.fileUrl,
          id: item.id,
        };
      });
      this.dataSource = new MatTableDataSource(transformed);
      this.pageParams.pageSize = data.meta.itemsPerPage;
      this.pageParams.pageIndex = data.meta.currentPage - 1;
      this.pageParams.length = data.meta.totalItems;
      this.showLoader = false;
    });
  }

  // getCountryNameByCode(code: string | number): string | undefined {
  //   return this.countriesList?.find((c: any) => c.code === code)?.name;
  // }

  searchSubmit() {
    const filters = this.prepareSearchParams();
    this.localStorageSvc.set('reportedTaxReportFilters', filters);
    this.getList(1, this.pageParams.pageSize, filters);
  }

  prepareSearchParams(): any {
    let fromYear: string | null = null;
    let fromMonth: string | null = null;
    let toYear: string | null = null;
    let toMonth: string | null = null;

    const fromValue = this.dateFrom.value;
    const toValue = this.dateTo.value;

    if (fromValue && moment.isMoment(fromValue)) {
      fromYear = fromValue.year().toString();
      fromMonth = (fromValue.month() + 1).toString().padStart(2, '0');
    }

    if (toValue && moment.isMoment(toValue)) {
      toYear = toValue.year().toString();
      toMonth = (toValue.month() + 1).toString().padStart(2, '0');
    }

    const params: any = {};

    if (fromYear && fromMonth) {
      params.fromYear = fromYear;
      params.fromMonth = fromMonth;
    }

    if (toYear && toMonth) {
      params.toYear = toYear;
      params.toMonth = toMonth;
    }

    if (this.partners.value?.length) {
      params.partnerId = this.partners.value;
    }

    if (this.customers.value?.length) {
      params.customerId = this.customers.value;
    }

    if (this.country.value?.length) {
      params.countryCode = this.country.value;
    }

    return params;
  }

  get showCountryFilter(): boolean {
    if (this.reportType === TaxReportType.Regular) {
      return (
        this.isAdmin ||
        this.isPartner ||
        !!this.userSvc.isDelegatedPartner ||
        this.isCustomerOrDelegateCustomer()
      );
    }
    if (this.reportType === TaxReportType.Purchases) {
      return this.isAdmin;
    }
    return false;
  }

  private isCustomerOrDelegateCustomer(): boolean {
    const r = this.localStorageSvc.get('user')?.role;
    return r === Roles.Customer || r === Roles.DelicateCustomer;
  }

  clearFilters(): void {
    this.dateFrom.setValue('');
    this.dateTo.setValue('');
    this.country.setValue([]);
    this.customers.setValue([]);
    if (!this.isPartner) {
      this.partners.setValue([]);
    }
    this.localStorageSvc.remove('reportedTaxReportFilters');
    this.getList();
  }

  getListCountries(): void {
    this.constSvc.getVatCountries().subscribe(data => {
      this.countriesList = data;
    });
  }

  getPartnersList(): void {
    this.partnerService.getPartnersList().subscribe(result => {
      this.partnerList = result;
    });
  }

  getCompanyList(page: number = this.previousPageCompany + 1, limit: number = 20000): void {
    this.companyService.getCustomersList(limit, page, '').subscribe(data => {
      if (!data) return;
      if (data.meta.currentPage > 1) {
        this.companyList = [...(this.companyList ?? []), ...data.items];
      } else {
        this.companyList = data.items;
      }
      this.previousPageCompany = data.meta.currentPage;
      this.totalPageCompany = data.meta.totalPages;
    });
  }

  getPartnerCompanyList(page: number = this.previousPageCompany + 1, limit: number = 20000): void {
    this.partnerService.getCustomListByPartner(limit, page, '', this.partnerId).subscribe(data => {
      if (!data) return;
      if (data.meta.currentPage > 1) {
        this.companyList = [...(this.companyList ?? []), ...data.items];
      } else {
        this.companyList = data.items;
      }
      this.previousPageCompany = data.meta.currentPage;
      this.totalPageCompany = data.meta.totalPages;
    });
  }


  getFlagClass(code: string) {
    return `iti__${code?.toLowerCase()}`;
  }

  pageChanged(e: PageParams): void {
    this.pageParams.pageIndex = e.pageIndex;
    this.pageParams.pageSize = e.pageSize;
    this.getList(this.pageParams.pageIndex + 1, this.pageParams.pageSize, this.prepareSearchParams());
  }

  removeTaxReport(reportId: number): void {
    this.showLoader = true;
    this.taxReportSvc.removeReportedTaxReport(reportId).subscribe(data => {
      this.showLoader = false;
      this.notify.showSuccessMessage("Tax Report Removed Successfully");
      this.getList();
    });
  }

  private getDisplayedColumns(reportType: number, role: Roles): string[] {
    const baseColumns = ['timePeriod', 'partnerName', 'customerName'];
    if (reportType === TaxReportType.Regular || reportType === TaxReportType.Purchases) {
      baseColumns.push('country');
    }
    baseColumns.push('action');

    if (role === Roles.Admin || role === Roles.DelicateAdmin) return baseColumns;
    if (role === Roles.PartnerAccount || role === Roles.DelegatePartnerAccount) {
      return baseColumns.filter(col => col !== 'partnerName');
    }
    return baseColumns.filter(col => col !== 'partnerName' && col !== 'customerName');
  }
}